<template>
  <div>
    <v-col sm="12">
      <v-card class="mx-auto" flat>
        <v-card-title class="mb-4">
          <h1 class="ma-0" style="font: inherit">快速健檢預約</h1>
        </v-card-title>
        <v-card-text>
          <v-form ref="form" lazy-validation>
            <v-text-field
              v-model="input.id"
              label="身分證字號"
              :rules="[(v) => !!v || `身分證字號為必填項目`]"
              outlined
              dense
            ></v-text-field>
            <v-text-field
              v-model="input.birth"
              label="生日"
              :rules="[
                (v) => !!v || `生日為必填項目`,
                (v) =>
                  /^\d?\d{6}$/.test(v) ||
                  `出生年月日格式錯誤，民國生日 6 碼，例如 35 年 04 月 11 日，請輸入 350411`,
              ]"
              outlined
              dense
              hint="例如 35 年 04 月 11 日，請輸入 350411"
              persistent-hint
            ></v-text-field>
          </v-form>
          <v-btn x-large class="my-4" color="primary" block @click="signup"
            >預約查詢</v-btn
          >
        </v-card-text>
      </v-card>
    </v-col>
  </div>
</template>

<script>
import ls from "expired-localstorage";
import { 健檢項目 } from "@/libs/const.js";
const shiftCharCode = (Δ) => (c) => String.fromCharCode(c.charCodeAt(0) + Δ);
export default {
  name: "P1",
  data() {
    return {
      input: {
        id: "",
        birth: "",
      },
      valid: false,
      person: null,
      items: 健檢項目,
    };
  },
  methods: {
    async signup() {
      this.input.id = this.input.id.replace(/[！-～]/g, shiftCharCode(-0xfee0));
      this.input.id = this.input.id.toUpperCase();
      this.input.id = this.input.id.trim();
      this.input.birth = this.input.birth.replace(
        /[！-～]/g,
        shiftCharCode(-0xfee0)
      );
      this.input.birth = this.input.birth.trim();

      this.valid = this.$refs.form.validate();
      if (this.valid) {
        let data = (await this.axios.post("/signin", this.input)).data;
        if (data.errMsg) {
          this.$toast.error(data.errMsg);
        } else {
          let person = data.person;

          this.$store.commit("setState", {
            person,
          });
          ls.set("token", data.token);
          this.$router.push("/quick/confirm");
        }
      }
    },
  },
};
</script>
